<script>
  export let sizes = [];
  export let genderToShow = '';
  export let productName = '';
</script>

<table>
  <div class="label">{genderToShow} {productName}</div>
  <tr>
    <th>Size</th>
    {#each sizes as size}
      {#if size.ProductSize.gender === genderToShow}
        <th class="uppercase">{size.ProductSize.name}</th>
      {/if}
    {/each}
  </tr>
  <tr>
    <th>Width </th>
    {#each sizes as size}
      {#if size.ProductSize.gender === genderToShow}
        <td>{size.width} {size.units}</td>
      {/if}
    {/each}
  </tr>
  {#if sizes[0]?.length && sizes[0].length !== ''}
    <tr>
      <th>Length </th>
      {#each sizes as size}
        {#if size.ProductSize.gender === genderToShow}
          <td
            >{size.length}
            {#if size.length !== ''}
              {size.units}
            {/if}</td
          >
        {/if}
      {/each}
    </tr>
  {/if}
</table>

<style>
  table {
    margin: 0 auto;
  }

  table,
  th,
  td {
    border: 1px solid black;
  }

  th,
  td {
    padding: 1rem;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .label {
    font-size: 2.4rem;
    text-align: center;
    display: block;
    text-transform: capitalize;
    padding: 1rem;
  }
</style>
